﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconShirt } from "@tabler/icons-react";
import { RopaDef } from "./RopaDef";

export const RopaIcon = IconShirt;

export class Ropa extends Entity<RopaDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RopaDef(), parentKeys);
        super.Form = import('./RopaForm').then((module) => module.RopaForm);
        this.Title = "Ropa";
        this.Icon = RopaIcon; 
    }
}